/**
* @ngdoc service
* @name common.newsletter.service:ItxNewsletterSvc
* @requires $q
* @description
* Newsletter service
*/
(function () {
    
    'use strict';

    angular.module('itxApp.common')
           .service('DialogSvc', DialogSvc);

    DialogSvc.$inject = [
        'ItxTranslateSvc',
        'ngDialog'
    ];

    function DialogSvc (
        ItxTranslateSvc,
        ngDialog
    ) {

        function Modal(message, title, buttonPrimary, buttonSecondary, cmsTranslate) {
            if (cmsTranslate) {
                this.message = message ? ItxTranslateSvc.translateCms(message) : '';
                this.title = title ? ItxTranslateSvc.translateCms(title) : '';
            } else {
                this.message = _getTranslation(message);
                this.title = _getTranslation(title);
            }

            this.buttonPrimary = {};
            this.buttonSecondary = {};
            if(buttonPrimary && buttonPrimary.event && buttonPrimary.text){
                this.buttonPrimary.event = buttonPrimary.event;

                if (cmsTranslate) {
                    this.buttonPrimary.text = ItxTranslateSvc.translateCms(buttonPrimary.text);
                } else {
                    this.buttonPrimary.text = _getTranslation(buttonPrimary.text);
                }
            } else {
                this.buttonPrimary = null;
            }
            if(buttonSecondary && buttonSecondary.event && buttonSecondary.text){
                this.buttonSecondary.event = buttonSecondary.event;

                if (cmsTranslate) {
                    this.buttonSecondary.text = ItxTranslateSvc.translateCms(buttonSecondary.text);
                } else {
                    this.buttonSecondary.text = _getTranslation(buttonSecondary.text);
                }
            } else {
                this.buttonSecondary = null;
            }
        }

        var service = {
            open: _open
        };
        return service;

        /* @Params
         * button = {
         *   event = function (){ngDialog.close()},
         *   text = 'accept';
         * }
         * DialogSvc.open( 'message', 'title', button, button, callback);
         */
        function _open(message, title, buttonPrimary, buttonSecondary, preCloseCallback, cmsTranslate) {
            var data = new Modal(message, title, buttonPrimary, buttonSecondary, cmsTranslate);

            if(!preCloseCallback){
                preCloseCallback = function () {};
            }

            return ngDialog.open({
                template: ['<div class="content-dialog">', 
                          ' <div class="ma-modal-header">',
                          '</div>',
                          ' <div class="ma-modal-body text-center">',
                          '     <h2 class="h4 mb-16" ng-if="::ngDialogData.title"', 
                          '         ng-bind="::ngDialogData.title">', 
                          '     </h2>', 
                          '     <h2 class="h4 mb-16" ng-if="::ngDialogData.message"', 
                          '         ng-bind-html="::ngDialogData.message">', 
                          '     </h2>', 
                          '<button type="button buttonPrimary" ng-if="ngDialogData.buttonPrimary"', 
                          '          class="btn btn-invert btn--small m-8 "', 
                          '          ng-click="ngDialogData.buttonPrimary.event()"', 
                          '          ng-bind="::ngDialogData.buttonPrimary.text">', 
                          '</button>',
                          '<button type="button buttonSecondary" ng-if="ngDialogData.buttonSecondary"', 
                          '          class="btn btn-primary btn--small  m-8 "', 
                          '          ng-click="ngDialogData.buttonSecondary.event()"', 
                          '          ng-bind="::ngDialogData.buttonSecondary.text">', 
                          '</button>', 
                          '</div>',
                          '</div>'].join(''), 
                plain: true,
                className: 'modal-tranversal new-modal ma-modal-sm error-dialog ngdialog-theme-plain ',
                showClose: true,
                data: data,
                preCloseCallback: preCloseCallback
            });
        }

        function _getTranslation(text) {
            if(text === null){
                return false;
            } else {
                var textTranslate = ItxTranslateSvc.translate(text);
                if(textTranslate.indexOf('???')>-1){
                    return text;
                } else {
                    return textTranslate;
                }
            }
        }
    }

})();